import * as React from 'react';

export interface INewbuildingPromoCarouselFallbackProps {
  onLoadableError: () => void;
}

export const NewbuildingPromoCarouselFallback: React.FC<INewbuildingPromoCarouselFallbackProps> = ({
  onLoadableError,
}) => {
  React.useEffect(onLoadableError, [onLoadableError]);

  return null;
};
